import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from './store';
import { ActivationStick } from '../interfaces';
import { getActivationSticks } from '../api/getActivationSticks';

export interface ActivationSticksState {
    items: ActivationStick[] | null;
}

const initialState: ActivationSticksState = {
    items: null,
};

export const loadActivationSticks = createAsyncThunk('activationSticks/load', async () => {
    return await getActivationSticks();
});

export const ActivationSticksSlice = createSlice({
    name: 'activationSticks',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(loadActivationSticks.fulfilled, (state, action) => {
                state.items = action.payload;
            })
            .addCase(loadActivationSticks.rejected, (state, action) => {
                console.error(action.error);
            });
    },
});

export const selectActivationSticks = (state: RootState) => state.activationSticks.items;

export default ActivationSticksSlice.reducer;
